var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from "styled-components";
import Flex from "../templates/flex";
import getPillBackground from "./mixins/background";
import { getPillColor } from "./mixins/colors";
import getPillHeight from "./mixins/height";
import getPillPadding from "./mixins/padding";
import getPillWidth from "./mixins/width";
export var MasterCardContainer = styled(Flex).attrs(function (_a) {
    var background = _a.background, height = _a.height, onClick = _a.onClick, _b = _a.round, round = _b === void 0 ? 999 : _b, size = _a.size;
    return (__assign(__assign({ background: background }, (onClick && { cursor: "pointer" })), { height: getPillHeight(height, size), round: round, size: size }));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  * {\n    cursor: ", ";\n  }\n"], ["\n  * {\n    cursor: ", ";\n  }\n"])), function (_a) {
    var onClick = _a.onClick;
    return (onClick ? "pointer" : "inherit");
});
export var PillContainer = styled(Flex).attrs(function (_a) {
    var _b = _a.round, round = _b === void 0 ? 999 : _b, hollow = _a.hollow, flavour = _a.flavour, borderColor = _a.borderColor, onClick = _a.onClick, padding = _a.padding, size = _a.size, tiny = _a.tiny, width = _a.width, height = _a.height, position = _a.position;
    return (__assign(__assign({ padding: getPillPadding(padding, size, tiny), round: round, border: {
            side: "all",
            color: borderColor || getPillColor(hollow ? "border" : "background", flavour),
            size: "1px",
        } }, (onClick && { cursor: "pointer" })), { height: getPillHeight(height, size, tiny), width: getPillWidth(width, tiny), justifyContent: "center", alignItems: "center", position: position }));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), getPillBackground);
var templateObject_1, templateObject_2;
